var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { App } from 'hermes-react-components-module';
import appProps from '../appProps.json';
import packageJson from '../package.json';
var appContainer = document.getElementById('app');
if (appContainer) {
    var root = createRoot(appContainer);
    root.render(_jsx(App, __assign({}, appProps, { versionText: "v".concat(packageJson.version) })));
}
